var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import Service from "./Service.js";
import debounce from "../utils/debounce.js";
class Scroll extends Service {
  constructor() {
    super(...arguments);
    __publicField(this, "props", {
      x: window.pageXOffset,
      y: window.pageYOffset,
      changed: {
        x: false,
        y: false
      },
      last: {
        x: window.pageXOffset,
        y: window.pageYOffset
      },
      delta: {
        x: 0,
        y: 0
      },
      max: {
        x: (document.scrollingElement || document.body).scrollWidth - window.innerWidth,
        y: (document.scrollingElement || document.body).scrollHeight - window.innerHeight
      },
      progress: {
        x: 0,
        y: 0
      },
      direction: {
        x: "NONE",
        y: "NONE"
      }
    });
  }
  init() {
    this.updateProps();
    document.addEventListener("scroll", this, { passive: true, capture: true });
    return this;
  }
  get debouncedHandler() {
    const debounced = debounce(() => {
      this.updateProps();
      this.trigger(this.props);
    }, 100);
    Object.defineProperty(this, "debouncedHandler", {
      value: debounced
    });
    return debounced;
  }
  handleEvent() {
    this.updateProps();
    this.trigger(this.props);
    this.debouncedHandler();
  }
  kill() {
    document.removeEventListener("scroll", this);
    return this;
  }
  updateProps() {
    const yLast = this.props.y;
    const xLast = this.props.x;
    if (window.pageYOffset !== this.props.y) {
      this.props.y = window.pageYOffset;
    }
    if (window.pageXOffset !== this.props.x) {
      this.props.x = window.pageXOffset;
    }
    this.props.changed.x = this.props.x !== xLast;
    this.props.changed.y = this.props.y !== yLast;
    this.props.last.x = xLast;
    this.props.last.y = yLast;
    this.props.delta.x = this.props.x - xLast;
    this.props.delta.y = this.props.y - yLast;
    this.props.max.x = (document.scrollingElement || document.body).scrollWidth - window.innerWidth;
    this.props.max.y = (document.scrollingElement || document.body).scrollHeight - window.innerHeight;
    this.props.progress.x = this.props.max.x === 0 ? 1 : this.props.x / this.props.max.x;
    this.props.progress.y = this.props.max.y === 0 ? 1 : this.props.y / this.props.max.y;
    this.props.direction.x = this.props.x > xLast ? "RIGHT" : this.props.x < xLast ? "LEFT" : "NONE";
    this.props.direction.y = this.props.y > yLast ? "DOWN" : this.props.y < yLast ? "UP" : "NONE";
    return this.props;
  }
}
let instance;
let scroll;
function useScroll() {
  if (!scroll) {
    if (!instance) {
      instance = new Scroll();
    }
    scroll = {
      add: instance.add.bind(instance),
      remove: instance.remove.bind(instance),
      has: instance.has.bind(instance),
      props() {
        return instance.props;
      }
    };
  }
  return scroll;
}
export {
  useScroll as default
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
